export function isAnonymized (record) {
  if (!record) {
    return false
  }
  if (record.anonymized) {
    return true
  }
  return !!(record.anonymized_ts && parseInt(record.anonymized_ts, 10))
}
